import { useState } from 'react';
import { domainTransferRequiredError, domainTransferError, userDomainTransferPost } from '../../../api/user/dashboard';
import { DISPLAY_LANG } from '../../../config';
import './DomainTransfer.css';

export default function DomainTransfer({ pageData }) {
  const [showLoading, setShowLoading] = useState(false);
  const [showConfirmText, setSHowConfirmText] = useState(false);
  const [input, setInput] = useState('');

  const submitHandler = async (event) => {
    event.preventDefault();

    if (!input.trim()) {
      return alert(domainTransferRequiredError[DISPLAY_LANG]);
    }

    setShowLoading(true);

    try {
      const res = await userDomainTransferPost(input);
      if (res) setSHowConfirmText(true);
      setInput('');
      setShowLoading(false);
    } catch (error) {
      console.log(error);
      setShowLoading(false);
      alert(domainTransferError[DISPLAY_LANG])
    }
  };

  return (
    <div className='DomainTransfer'>
      <h2>{pageData.domain_transfer_title}</h2>
      <p className='domain_transfer_descr'>{pageData.domain_transfer_descr}</p>

      <form className="transfer-form" onSubmit={submitHandler}>
        <label htmlFor="transfer-input">{pageData.domain_transfer_label}</label>

        <div className='flex-center'>
          <input type="text" id='transfer-input' value={input} onChange={e => setInput(e.target.value)} />
          <button type='submit' className='btn'>
            {pageData.domain_transfer_btn_text}
            {showLoading && <span className="spinner"></span>}
          </button>
        </div>
      </form>

      {showConfirmText && <div className="confirm_text">
        <img src="/images/partials/icon-check-one.svg" alt="check" />
        <p className='domain_transfer_client_message'>{pageData.domain_transfer_client_message}</p>
      </div>}
    </div>
  )
}
